import Tab from "components/Tab";
import WebLogging from "../../../../contents/docs/session-replay/_snippets/web-logging.mdx";
import AndroidLogging from "../../../../contents/docs/session-replay/_snippets/android-logging.mdx";
import ReactNativeLogging from "../../../../contents/docs/session-replay/_snippets/react-native-logging.mdx";
import IOSLogging from "../../../../contents/docs/session-replay/_snippets/ios-logging.mdx";
import * as React from 'react';
export default {
  Tab,
  WebLogging,
  AndroidLogging,
  ReactNativeLogging,
  IOSLogging,
  React
};